import { CustomerRegistrationSource } from "src/publicproxy/src/proxy/public/application/contracts";

const REGISTRATION_CONTEXT_KEY = 'customer-registration-context';

export class EnvService {
    private tracking = false;
    private trackLog = false;
    private public = true;

    private envFileLoaded = false;

    public visitSource?: CustomerRegistrationSource;
    public visitSourceStore?: string;
    public visitSourceSector?: string;

    constructor() {
        this.restoreRegistrationContext();
    }

    public trackingEnabled(): boolean {
        return this.envFileLoaded ? this.tracking : false;
    }

    public trackLogEnabled(): boolean {
        return this.envFileLoaded ? this.trackLog : false;
    }

    public isPublic(): boolean {
        return this.envFileLoaded ? this.public : false;
    }

    public saveRegistrationContext(
        source: CustomerRegistrationSource,
        store?: string,
        sector?: string,
    ): void {
        this.visitSource = source;
        this.visitSourceStore = store;
        this.visitSourceSector = sector;

        window.sessionStorage.setItem(REGISTRATION_CONTEXT_KEY, JSON.stringify({ source, store, sector }));
    }

    public clearRegistrationContext(): void {
        this.visitSource = undefined;
        this.visitSourceStore = undefined;
        this.visitSourceSector = undefined;
        window.sessionStorage.removeItem(REGISTRATION_CONTEXT_KEY);
    }

    private restoreRegistrationContext(): void {
        const value = window.sessionStorage.getItem(REGISTRATION_CONTEXT_KEY);
        if (!value) {
            return;
        }

        try {
            const context = JSON.parse(value) as {
                source?: CustomerRegistrationSource;
                store?: string;
                sector?: string;
            };
            this.visitSource = context.source;
            this.visitSourceStore = context.store;
            this.visitSourceSector = context.sector;
        } catch {
            window.sessionStorage.removeItem(REGISTRATION_CONTEXT_KEY);
        }
    }
}
